<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Card>
        <template #title>
          <div class="p-d-flex p-justify-between">
            <span v-if="trainingDocument.id"
              >เอกสารการฝึกอบรม {{ trainingDocument.id }}
            </span>
            <span v-else>สร้างเอกสารใหม่</span>
            <div>
              <Button
                label="รายชื่อผู้เข้าอบรม"
                icon="pi pi-download"
                class="p-ml-2 p-button-outlined p-button-info"
                @click="onDownloadAttendanceList"
              />
              <Button
                label="QRCode"
                icon="pi pi-external-link"
                class="p-ml-2 p-button-outlined p-button-success"
                @click="onShowQrCode"
              >
              </Button>
              <Button
                label="บันทึก"
                icon="pi pi-save"
                @click="onSaveTrainingDocument"
                class="p-ml-5"
                :disabled="isReadonly"
              >
              </Button>
              <Button
                label="ใช้งาน"
                icon="pi pi-send"
                @click="onReleaseTrainingDocument"
                class="p-ml-2 p-button-danger"
                :disabled="isReadonly"
              >
              </Button>
              <CancelButton
                v-if="
                  isAdmin() &&
                    !trainingDocument.cancelOn &&
                    !trainingDocument.completedOn
                "
                class="p-ml-2"
                @cancel="onCancelDocument"
              />
              <CompleteButton
                v-if="
                  isAdmin() &&
                    trainingDocument.releaseOn &&
                    !trainingDocument.cancelOn &&
                    !trainingDocument.completedOn
                "
                class="p-ml-2"
                @complete="onCompleteDocument"
              />
              <back-button class="p-ml-2" />
            </div>
          </div>
        </template>
        <template #subtitle="">
          <StatusBadge :status="trainingDocument.status" />
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <TabView>
        <TabPanel header="รายละเอียด">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-field">
              <label class="p-text-bold">หลักสูตร</label>
              <div>
                {{ trainingDocument.courseId }} :
                {{ trainingDocument.course?.description ?? "N/A" }}
              </div>
            </div>
            <div class="p-col-12 p-md-4 p-field">
              <label class="p-text-bold">ประเภทหลักสูตร</label>
              <div>
                {{ trainingDocument.course?.courseTypeId ?? "N/A" }} :
                {{ trainingDocument.course?.courseType?.description ?? "N/A" }}
              </div>
            </div>
            <div class="p-col-12 p-md-4 p-field">
              <label class="p-text-bold">ประเภทการอบรม</label>
              <div>
                <!-- {{ trainingDocument.trainingType }} : -->
                {{ trainingTypeDesc(trainingDocument.trainingType ?? 0) }}
              </div>
            </div>

            <div class="p-col-12 p-lg-4 p-md-4 p-field p-fluid">
              <span class="p-float-label">
                <Calendar
                  id="calendar"
                  v-model="selectedDate"
                  selectionMode="range"
                  :disabled="isReadonly"
                ></Calendar>
                <label for="calendar">ระบุวันที่อบรม</label>
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid">
              <span class="p-float-label">
                <InputMask
                  v-model="trainingDocument.time"
                  id="time"
                  mask="99:99-99:99"
                  :class="{ 'p-invalid': v$.trainingDocument.time.$error }"
                  :disabled="isReadonly"
                ></InputMask>
                <label for="time">ระบุช่วงเวลา</label>
              </span>
              <small
                class="p-error"
                v-for="error in v$.trainingDocument.time.$errors"
                :key="error.$uid"
                >{{ error.$message }}</small
              >
            </div>
            <div class="p-col-12 p-md-4 p-fluid">
              <div class="p-inputgroup">
                <span class="p-float-label">
                  <InputNumber
                    v-model="trainingDocument.hours"
                    id="hours"
                    :class="{ 'p-invalid': v$.trainingDocument.hours.$error }"
                    :disabled="isReadonly"
                    mode="decimal"
                    :minFractionDigits="2"
                  ></InputNumber>
                  <label for="hours">จำนวนชั่วโมง</label>
                </span>
                <span class="p-inputgroup-addon">
                  ชั่วโมง
                </span>
              </div>

              <small
                class="p-error"
                v-for="error in v$.trainingDocument.hours.$errors"
                :key="error.$uid"
                >{{ error.$message }}</small
              >
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputText
                  id="location"
                  type="text"
                  v-model="trainingDocument.location"
                  :disabled="isReadonly"
                  :class="{ 'p-invalid': v$.trainingDocument.location.$error }"
                ></InputText>
                <label for="location">สถานที่อบรม</label>
              </span>

              <small
                class="p-error"
                v-for="error in v$.trainingDocument.location.$errors"
                :key="error.$uid"
                >{{ error.$message }}</small
              >
            </div>

            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputNumber
                  id="inputDunning1"
                  v-model="trainingDocument.dunning1"
                  :disabled="isReadonly"
                  :class="{ 'p-invalid': v$.trainingDocument.dunning1.$error }"
                ></InputNumber>
                <label for="inputDunning1">จำนวนวันติดตามงานครั้งที่ 1</label>
              </span>
              <small
                class="p-error"
                v-for="error in v$.trainingDocument.dunning1.$errors"
                :key="error.$uid"
              >
                {{ error.$message }}
              </small>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputNumber
                  id="inputDunning2"
                  v-model="trainingDocument.dunning2"
                  :disabled="isReadonly"
                  :class="{ 'p-invalid': v$.trainingDocument.dunning2.$error }"
                ></InputNumber>
                <label for="inputDunning2">จำนวนวันติดตามงานครั้งที่ 2</label>
              </span>
              <small
                class="p-error"
                v-for="error in v$.trainingDocument.dunning2.$errors"
                :key="error.$uid"
              >
                {{ error.$message }}
              </small>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputQuestion
                  id="instructorQuestionId"
                  v-model="trainingDocument.instructorQuestionId"
                  :disabled="isReadonly"
                ></InputQuestion>
                <label for="instructorQuestionId">แบบประเมินวิทยากร</label>
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputQuestion
                  id="satisfactionQuestionId"
                  v-model="trainingDocument.satisfactionQuestionId"
                  :disabled="isReadonly"
                ></InputQuestion>
                <label for="satisfactionQuestionId"
                  >แบบประเมินความพึงพอใจ</label
                >
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputQuestion
                  id="knowledgeQuestionId"
                  v-model="trainingDocument.knowledgeQuestionId"
                  :disabled="isReadonly"
                ></InputQuestion>
                <label for="knowledgeQuestionId">แบบประเมินความรู้</label>
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid">
              <div class="p-field">
                <div
                  class="p-inputgroup"
                  v-if="!!trainingDocument.instructorQuestionId"
                >
                  <span class="p-float-label">
                    <InputNumber
                      id="instructorWaitingPeriod"
                      v-model="trainingDocument.instructorWaitingPeriod"
                      :disabled="isReadonly"
                    ></InputNumber>
                    <label for="instructorWaitingPeriod"
                      >ทำแบบประเมินวิทยากรได้ใน</label
                    >
                  </span>
                  <span class="p-inputgroup-addon">
                    วัน
                  </span>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-4 p-fluid">
              <div class="p-field">
                <div
                  class="p-inputgroup"
                  v-if="!!trainingDocument.satisfactionQuestionId"
                >
                  <span class="p-float-label">
                    <InputNumber
                      id="satisfactionWaitingPeriod"
                      v-model="trainingDocument.satisfactionWaitingPeriod"
                      :disabled="isReadonly"
                    ></InputNumber>
                    <label for="satisfactionWaitingPeriod"
                      >ทำแบบประเมินความพึงพอใจได้ใน</label
                    >
                  </span>
                  <span class="p-inputgroup-addon">
                    วัน
                  </span>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-4 p-fluid">
              <div class="p-field">
                <div
                  class="p-inputgroup"
                  v-if="!!trainingDocument.knowledgeQuestionId"
                >
                  <span class="p-float-label">
                    <InputNumber
                      id="knowledgeWaitingPeriod"
                      v-model="trainingDocument.knowledgeWaitingPeriod"
                      :disabled="isReadonly"
                    ></InputNumber>
                    <label for="knowledgeWaitingPeriod"
                      >ทำแบบประเมินความรู้ได้ใน</label
                    >
                  </span>
                  <span class="p-inputgroup-addon">
                    วัน
                  </span>
                </div>
              </div>
            </div>
            <template
              v-if="trainingDocument.trainingType === TrainingTypeEnum.Internal"
            >
              <div class="p-col-12 p-md-4 p-fluid p-field">
                <span class="p-float-label">
                  <InputUser
                    id="InputUser1"
                    v-model="trainingDocument.internalInstructorId1"
                    :disabled="isReadonly"
                  ></InputUser>
                  <label for="InputUser1">วิทยากรภายใน 1</label>
                </span>
              </div>
              <div class="p-col-12 p-md-4 p-fluid p-field">
                <span class="p-float-label">
                  <InputUser
                    id="InputUser2"
                    v-model="trainingDocument.internalInstructorId2"
                    :disabled="isReadonly"
                  ></InputUser>
                  <label for="InputUser2">วิทยากรภายใน 2</label>
                </span>
              </div>
              <div class="p-col-12 p-md-4 p-fluid p-field">
                <span class="p-float-label">
                  <InputUser
                    id="InputUser3"
                    v-model="trainingDocument.internalInstructorId3"
                    :disabled="isReadonly"
                  ></InputUser>
                  <label for="InputUser3">วิทยากรภายใน 3</label>
                </span>
              </div>
            </template>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputInstructor
                  id="inputInstructor1"
                  v-model="trainingDocument.instructorId1"
                  :disabled="isReadonly"
                ></InputInstructor>
                <label for="inputInstructor1">วิทยากรภายนอก 1</label>
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputInstructor
                  id="inputInstructor2"
                  v-model="trainingDocument.instructorId2"
                  :disabled="isReadonly"
                ></InputInstructor>
                <label for="inputInstructor2">วิทยากรภายนอก 2</label>
              </span>
            </div>
            <div class="p-col-12 p-md-4 p-fluid p-field">
              <span class="p-float-label">
                <InputInstructor
                  id="inputInstructor3"
                  v-model="trainingDocument.instructorId3"
                  :disabled="isReadonly"
                ></InputInstructor>
                <label for="inputInstructor3">วิทยากรภายนอก 3</label>
              </span>
            </div>
            <div class="p-col-12 p-fluid p-field">
              <label for="remark">รายละเอียดอื่น ๆ</label>
              <Textarea
                id="remark"
                v-model="trainingDocument.remark"
                style="width: 100%"
                :rows="5"
                :disabled="isReadonly"
              ></Textarea>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="ผู้เข้าอบรม">
          <TrainingAttendanceList
            :items="trainingAttendances"
            :document="trainingDocument"
            :disabled="isReadonly"
          ></TrainingAttendanceList>
        </TabPanel>
      </TabView>
    </div>
  </div>
  <Dialog v-model:visible="showQrPopup" header="QR Code" modal>
    <div class="container">
      <div class="p-grid">
        <div class="p-col-12">
          QR Code สำหรับ Scan เพื่อทำแบบประเมินของการอบรม
        </div>
        <div class="p-col-12 p-text-center">
          <img :src="qrCode" style="height: 40vh" />
        </div>
        <div class="p-col-12 p-text-center">
          {{ qrCodeRaw }}
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, computed } from "vue";
import {
  Course,
  TrainingDocument,
  TrainingDetailDto,
  TrainingAttendance,
  UpsertTrainingDocumentRequest,
  CancelTrainingDocumentRequest,
  DownloadTrainingAttendanceRequest,
  TrainingTypeEnum,
} from "@/types";
import { usePlugin } from "@/plugins";
import TrainingAttendanceList from "../../components/TrainingAttendanceList.vue";
import InputInstructor from "@/components/InputInstructor.vue";
import InputUser from "@/components/InputUser.vue";
import InputQuestion from "@/components/InputQuestion.vue";
import BackButton from "@/components/BackButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import CompleteButton from "@/components/CompleteButton.vue";
import StatusBadge from "@/components/StatusBadge.vue";
import { useQRCode } from "@vueuse/integrations";
import { useConfirm } from "primevue/useconfirm";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { saveAs } from "file-saver";

export default defineComponent({
  name: "TrainingDocumentMaintain",
  components: {
    TrainingAttendanceList,
    InputInstructor,
    InputQuestion,
    BackButton,
    CancelButton,
    StatusBadge,
    InputUser,
    CompleteButton,
  },
  setup() {
    const {
      success,
      error,
      axios,
      setLoading,
      route,
      trainingTypeDesc,
      formatDate,
      dayjs,
      formatAppDateTime,
      useState,
      isAdmin,
    } = usePlugin();
    const confirm = useConfirm();
    const course = ref<Course>({} as Course);
    const trainingDocument = ref<TrainingDocument>({} as TrainingDocument);
    const trainingAttendances = ref<TrainingAttendance[]>([]);
    const selectedDate = ref<Date[]>([dayjs().toDate(), dayjs().toDate()]);

    const newRules = {
      trainingDocument: {
        trainingType: { required },
        courseId: { required },
        location: { required },
        startDate: { required },
        endDate: { required },
        time: { required },
        hours: { required },
        dunning1: { required },
        dunning2: { required },
      },
    };
    const v$ = useVuelidate(newRules, { trainingDocument });

    const loadTrainingDocument = async () => {
      if (route.params.docNo) {
        setLoading(true);
        try {
          const result = await axios.get<TrainingDetailDto>(
            `api/v1/services/trainingDocument/${route.params.docNo}`
          );
          trainingDocument.value =
            result.data.trainingDocument ?? ({} as TrainingDocument);
          trainingDocument.value.startDate = dayjs(
            trainingDocument.value.startDate
          ).toDate();
          trainingDocument.value.endDate = dayjs(
            trainingDocument.value.endDate
          ).toDate();

          course.value = result.data.trainingDocument?.course ?? ({} as Course);
          trainingAttendances.value = result.data.trainingAttendances ?? [];

          selectedDate.value = [
            result.data.trainingDocument?.startDate ?? dayjs().toDate(),
            result.data.trainingDocument?.endDate ?? dayjs().toDate(),
          ];
          // await prepTrainingAttendance();
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };
    // const prepTrainingAttendance = async () => {
    //   if (trainingAttendances.value) {
    //     for (let i = 0; i < trainingAttendances.value.length; i++) {
    //       const trainingAttendance = trainingAttendances.value[i];

    //       const user = await searchUser(trainingAttendance?.employeeId);
    //       if (user && user.length > 0) {
    //         const trainingAttendanceDto = {
    //           trainingDocumentId: trainingAttendance.trainingDocumentId,
    //           employeeId: trainingAttendance.employeeId,
    //           internalAssessmentData: trainingAttendance.internalAssessmentData,
    //           externalAssessmentData: trainingAttendance.externalAssessmentData,
    //           knowledgeAssessmentData:
    //             trainingAttendance.knowledgeAssessmentData,
    //           User: {
    //             ...user[0],
    //             fullName: `${user[0].prename} ${user[0].name} ${user[0].surname}`,
    //           },
    //         };
    //         trainingAttendancesDto.value.push(trainingAttendanceDto);
    //       }
    //     }
    //   }
    //   syncData.value = true;
    // };

    const onReleaseTrainingDocument = () => {
      confirm.require({
        header: "เริ่มใช้งาน",
        message: "ยืนยันเริ่มใช้งานเอกสาร Training",
        acceptLabel: "ยืนยันใช้งาน",
        accept: async () => {
          await onSaveTrainingDocument(true);
        },
        rejectLabel: "ยกเลิก",
      });
    };
    const state = useState();
    const onCancelDocument = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/trainingDocument/cancel", {
          trainingDocumentId: trainingDocument.value.id,
        } as CancelTrainingDocumentRequest);
        success("ยกเลิกเอกสารเรียบร้อยแล้ว");
        await loadTrainingDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const onCompleteDocument = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/trainingDocument/complete", {
          trainingDocumentId: trainingDocument.value.id,
        } as CancelTrainingDocumentRequest);
        success("ยืนยันสิ้นสุดกระบวนการเรียบร้อยแล้ว");
        await loadTrainingDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const onSaveTrainingDocument = async (submit = false) => {
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      setLoading(true);
      const trainingDocumentUpdate = {
        id: trainingDocument.value.id,
        courseId: trainingDocument.value.courseId,
        startDate: selectedDate.value[0],
        endDate: selectedDate.value[1],
        location: trainingDocument.value.location,
        course: trainingDocument.value.course,
        trainingType: trainingDocument.value.trainingType,
        instructorId1: trainingDocument.value.instructorId1,
        instructorId2: trainingDocument.value.instructorId2,
        instructorId3: trainingDocument.value.instructorId3,
        internalInstructorId1: trainingDocument.value.internalInstructorId1,
        internalInstructorId2: trainingDocument.value.internalInstructorId2,
        internalInstructorId3: trainingDocument.value.internalInstructorId3,
        instructorQuestionId: trainingDocument.value.instructorQuestionId,
        satisfactionQuestionId: trainingDocument.value.satisfactionQuestionId,
        knowledgeQuestionId: trainingDocument.value.knowledgeQuestionId,
        instructorWaitingPeriod: trainingDocument.value.instructorWaitingPeriod,
        satisfactionWaitingPeriod:
          trainingDocument.value.satisfactionWaitingPeriod,
        knowledgeWaitingPeriod: trainingDocument.value.knowledgeWaitingPeriod,
        dunning1: trainingDocument.value.dunning1,
        dunning2: trainingDocument.value.dunning2,
        hours: trainingDocument.value.hours,
        time: trainingDocument.value.time,
        remark: trainingDocument.value.remark,
      } as TrainingDocument;

      if (submit === true) {
        trainingDocumentUpdate.releaseOn = dayjs().toDate();
        trainingDocumentUpdate.releaseById =
          state.value.authentication.username;
      }

      try {
        const result = await axios.post(
          "api/v1/services/trainingDocument/upsert",
          {
            trainingDocuments: [trainingDocumentUpdate],
          } as UpsertTrainingDocumentRequest
        );
        success("บันทึกข้อมูลสำเร็จแล้ว");
        // emit("newTrainingDocument");
        await loadTrainingDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const showQrPopup = ref(false);
    const qrCodeRaw = computed(
      () =>
        `${window.origin}/#/training/assessment/${trainingDocument.value.id}`
    );
    const qrCode = useQRCode(qrCodeRaw);
    const onShowQrCode = () => {
      showQrPopup.value = true;
    };
    const isReadonly = computed(() => {
      return (
        trainingDocument.value.releaseOn !== null ||
        trainingDocument.value.cancelOn !== null
      );
    });

    const onDownloadAttendanceList = async () => {
      setLoading(true);
      try {
        const result = await axios.post(
          "api/v1/services/trainingAttendance/download",
          {
            id: trainingDocument.value.id,
          } as DownloadTrainingAttendanceRequest,
          { responseType: "blob" }
        );
        saveAs(
          result.data,
          `ATT_${trainingDocument.value.id}_${dayjs().format(
            "YYYY-MM-DD_HHmmss"
          )}.xlsx`
        );
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadTrainingDocument();
    });

    return {
      trainingDocument,
      selectedDate,
      trainingAttendances,
      course,
      trainingTypeDesc,
      formatDate,
      onSaveTrainingDocument,
      onReleaseTrainingDocument,
      onDownloadAttendanceList,
      onCancelDocument,
      onCompleteDocument,

      onShowQrCode,
      showQrPopup,
      qrCode,
      qrCodeRaw,

      formatAppDateTime,
      isReadonly,
      isAdmin,

      v$,

      TrainingTypeEnum,
    };
  },
});
</script>

<style></style>
